import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { VariableFormat } from '../number-sequence'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ElderMaxValidator, ElderMinValidator } from '@elderbyte/ngx-starter'
import { FormsModule } from '@angular/forms'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field'

@Component({
  selector: 'app-variable-format-detail',
  templateUrl: './variable-format-detail.component.html',
  styleUrls: ['./variable-format-detail.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    ElderMinValidator,
    ElderMaxValidator,
    MatHint,
    ElderTranslatePipe,
  ],
})
export class VariableFormatDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  @Input()
  public format: VariableFormat

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}
}
